import { Component, Input } from '@angular/core';
import { ExtractedMultipleShowcase, ShowcasesEntity, ShowcasesTypes } from 'search/full-card/models/showcases';
import { EntityTypes } from '../../../../../../entity/models/entity';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-multiple-showcase',
  templateUrl: './multiple-showcase.component.html',
  styleUrls: ['./multiple-showcase.component.scss'],
})
export class MultipleShowcaseComponent {
  @Input() public showcase: ExtractedMultipleShowcase;
  @Input() public index: number;
  @Input() public entity: ShowcasesEntity;
  @Input() public showcaseType: ShowcasesTypes;
  public resourcesPerMultipleShowcase = 7;
  public entityTypes = EntityTypes;
  public showcasesTypes = ShowcasesTypes;
  public readonly arrowIconRight = faAngleRight;
}
